import { useState } from "react";
import { ReplyAttachment } from "../types";

const initialState: ReplyAttachment = {
  authorID: "",
  timeToken: "",
  authorName: "",
  authorType: "",
  authorProfileImgURL: "",
  attachedText: "",
  ogMessageType: "",
};

export const useReplyAttachment = () => {
  const [replyAttachment, setReplyAttachment] =
    useState<ReplyAttachment>(initialState);

  const resetReplyAttachment = () => {
    setReplyAttachment(initialState);
  };

  return {
    replyAttachment,
    setReplyAttachment,
    resetReplyAttachment,
  };
};
